export class SizeProcessor {
    constructor(sizeHelper) {
        this.sizeHelper = sizeHelper;
        this.lastEvaluation = '';
        this.name = SizeProcessor.name;
    }
    invoke(productItem, attrComputer) {
        this.sizeHelper.evaluate();
        const evaluation = this.sizeHelper.toString();
        // Do not run if nothing has changed regarding size settings
        if (this.lastEvaluation != evaluation) {
            this.lastEvaluation = evaluation;
            let widthMM = this.sizeHelper.width.mm;
            let heightMM = this.sizeHelper.height.mm;
            console.log('SizeHelper try auto fit', widthMM, heightMM);
            if (this.sizeHelper.fixedSize) {
                // Auto fit to size constraints
                let currentDimensionsFoundInSizeOptions = false;
                const sizeOptions = attrComputer.getSuggestedValues('size');
                let defaultSizeOption = null;
                let defaultMeassures = null;
                const convertedMeasures = [];
                for (const sizeOptionIndex in sizeOptions) {
                    const sizeOption = sizeOptions[sizeOptionIndex];
                    const meassures = this.sizeHelper.extractMeassuresFromString(sizeOption);
                    if (!defaultMeassures) {
                        defaultMeassures = meassures;
                        defaultSizeOption = sizeOption;
                    }
                    const widthOptionInMM = this.sizeHelper.localizedToMM(meassures.width);
                    const heightOptionInMM = this.sizeHelper.localizedToMM(meassures.height);
                    convertedMeasures[sizeOptionIndex] = [widthOptionInMM, heightOptionInMM];
                    if (widthMM == widthOptionInMM && heightOptionInMM == heightMM) {
                        currentDimensionsFoundInSizeOptions = true;
                        break;
                    }
                }
                if (!currentDimensionsFoundInSizeOptions && defaultMeassures && defaultSizeOption) {
                    const closest = this.findClosestMatch(convertedMeasures, widthMM, heightMM);
                    // The discrepency with Epoxy (3") is 1.26
                    if ((closest === null || closest === void 0 ? void 0 : closest.distance) && closest.distance < 1.5) {
                        productItem.setAttribute('size', String(closest.index));
                        console.log('Size difference is within 1.5 mm, not adjusting size.');
                    }
                    else {
                        console.log('Auto fit to fixed meassures', 'from', widthMM, heightMM);
                        productItem.setAttribute('size', defaultSizeOption);
                        widthMM = this.sizeHelper.setMeasureAttrLocalized('width_mm', defaultMeassures.width);
                        heightMM = this.sizeHelper.setMeasureAttrLocalized('height_mm', defaultMeassures.height);
                        console.log('...to', widthMM, heightMM, defaultMeassures);
                    }
                }
            }
            const maxSide = Math.max(widthMM, heightMM);
            const minSide = Math.min(widthMM, heightMM);
            if (this.sizeHelper.hasMaxSizeOtherSide() && [maxSide, minSide].every((side) => side > this.sizeHelper.maxSizeOtherSide.mm)) {
                console.log('Auto fit because larger than max size other side', this.sizeHelper.maxSizeOtherSide.mm);
                const ratio = minSide / this.sizeHelper.maxSizeOtherSide.mm;
                this.sizeHelper.setMeasureAttrInMM('width_mm', widthMM / ratio);
                this.sizeHelper.setMeasureAttrInMM('height_mm', heightMM / ratio);
            }
            else if (maxSide > this.sizeHelper.maxSize.mm) {
                console.log('Auto fit because larger than max size', this.sizeHelper.maxSize.mm);
                const ratio = maxSide / this.sizeHelper.maxSize.mm;
                this.sizeHelper.setMeasureAttrInMM('width_mm', widthMM / ratio);
                this.sizeHelper.setMeasureAttrInMM('height_mm', heightMM / ratio);
            }
            else if (minSide < this.sizeHelper.minSize.mm) {
                console.log('Auto fit because smaller than min size', this.sizeHelper.minSize.mm);
                const ratio = this.sizeHelper.minSize.mm / minSide;
                this.sizeHelper.setMeasureAttrInMM('width_mm', widthMM * ratio);
                this.sizeHelper.setMeasureAttrInMM('height_mm', heightMM * ratio);
            }
        }
    }
    //TODO: This is purely to find the closest match for Epoxy 3" x 1.5", which gets converted to 76mm x 38mm,
    //instead of 77mm x 38mm. It calculated the difference (distance) which in this case is 1.
    //Then the set filter (of 76mm) is ignored and not enforced. This should probably be done the other way around.
    findClosestMatch(arrayOfArrays, inputNumber1, inputNumber2) {
        let closestMatch = null;
        let minDistance = Number.MAX_SAFE_INTEGER;
        for (let i = 0; i < arrayOfArrays.length; i++) {
            const distance = Math.abs(inputNumber1 - arrayOfArrays[i][0]) + Math.abs(inputNumber2 - arrayOfArrays[i][1]);
            if (distance < minDistance) {
                minDistance = distance;
                closestMatch = { index: i, distance };
            }
        }
        return closestMatch;
    }
}
